/** The closed sections of the manual (the rider and partner sections are open and need no grant). */
export const MANUAL_ACCESS_AUDIENCES = ['TEAM', 'DEVELOPER'];
const enc = encodeURIComponent;
export class ManualAccessAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The active grants, newest first (`manual_access:manage`). */
    list() {
        return this.client.request({ method: 'GET', path: '/v1/admin/manual-access', auth: true });
    }
    /** 201 `{ created: true }` for a new grant, 200 `{ created: false }` when the account already held the audience (`manual_access:manage`). */
    grant(input) {
        return this.client.request({
            method: 'POST', path: '/v1/admin/manual-access', body: { userId: input.userId, audience: input.audience, reasonCode: input.reasonCode }, auth: true,
        });
    }
    /** Revoke one grant (`manual_access:manage`); `changed: false` when it was already revoked. */
    revoke(grantId, reasonCode) {
        return this.client.request({
            method: 'POST', path: `/v1/admin/manual-access/${enc(grantId)}/revoke`, body: { reasonCode }, auth: true,
        });
    }
}
//# sourceMappingURL=manual-access.js.map